import { analyticsConstants } from '../../constants';
import { TrackingUtilsService } from './tracking-utils.service';
import {
  GlobalAnalyticsVariablesInterface,
  TrackPageInteractionInterface,
} from '../interfaces';
import { retrieveMergeResponseGlobalVarsCase } from './retrieve-merge-response-global-vars.case';
import { TelemetryGenericEnum } from '../../shared/enums';

export const trackPageInteractionPayloadCase = (
  payload: any,
  trackingUtilsService: TrackingUtilsService,
  globalVariables: GlobalAnalyticsVariablesInterface
): TrackPageInteractionInterface => {
  let interactionValue = '';
  if (payload?.interaction) {
    interactionValue = `${analyticsConstants.APP_NAME}:${payload.interaction}`;
  } else {
    interactionValue = `${analyticsConstants.APP_NAME}: ${payload}`;
  }
  const data = {
    eventType: analyticsConstants.INTERACTION_EVENT_TYPE,
    interaction: interactionValue,
    fluidVariable: trackingUtilsService.getTrackingGuestStatus(),
    olciPassengerIds:
      trackingUtilsService.getSelectedGuest() ??
      TelemetryGenericEnum.EMPTY_VALUE,
  };
  return retrieveMergeResponseGlobalVarsCase(
    true,
    validatePayloadIsObjectType(payload, data),
    globalVariables
  );
};

const validatePayloadIsObjectType = (
  payload: any,
  data: object
): string | object => {
  return typeof payload === 'object' ? { ...payload, ...data } : { ...data };
};
